import { useEffect, useState } from 'react'
import { useRecordContext, Datagrid } from 'react-admin'
import {
  Button,
  Typography,
  makeStyles,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
} from '@material-ui/core'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import '@typeform/embed/build/css/popup.css'
import Slide from '@mui/material/Slide'
import Api from '../Apis/api.service'
import Menus from './Menus'
import { DialogCourrier } from './Content/partials/DialogCourrier'
import useAxiosPrivate from '../hooks/useAxiosPrivate'
import config from '../config'
import LoadingScreen from '../common/LoadingScreen/components/LoadingScreen'
const useStyles = makeStyles({
  buttonLogout: {
    position: 'fixed',
    background: 'white',
    color: '#143A5F',
    fontSize: '11px',
    fontWeight: '500',
    padding: '.5em 4em',
    right: 9,
    top: 9,
    width: '5em',
    zIndex: 9999,
    '&:hover': {
      background: '#143A5F !important',
      color: '#ffffff !important',
    },
  },
  buttonWrapper: {
    margin: '-9px',
  },
  button: {
    margin: '9px',
  },
  servicesTitle: {
    // marginTop: "12px",
    marginBottom: '10px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    p: {
      img: { width: '35px', position: 'relative', top: '6px' },
    },
  },
  card: {
    '&:hover': {
      boxShadow: '1px 0px 40px 10px rgb(0 0 0 / 35%)',
    },
  },
  center: {
    textAlign: 'center',
  },
  icons: {
    width: '25px',
    marginRight: '8px',
  },
  created_at_style: {
    fontSize: '12px',
    color: 'grey',
    position: 'absolute',
    right: '1rem',
    marginTop: '-25px',
  },
  gridWithoutBorders: {
    border: 'none!important',
    boxShadow: 'none!important',
    '& *': {
      border: 'none!important',
      boxShadow: 'none!important',
    },
  },
  spacingMarginTop: {
    marginTop: '180px',
  },
  spacingPaddingTop: {
    paddingTop: '180px',
  },
})

const CoproGeneralNewRender = ({ setOpenNewsDialog }) => {
  const record = useRecordContext()
  const classes = useStyles()
  if (!record) return null
  const removeTags = (input) => (input ? input.replace(/<[^>]+>/gm, '') : '')

  return (
    <Slide direction="right" in={true} mountOnEnter>
      <Grid style={{ padding: 14 }} item xs={12}>
        <span className={classes.created_at_style}>{record.published_at}</span>
        <p>
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: record.description }}
          />
        </p>
      </Grid>
    </Slide>
  )
}

const Portal = ({ coproprietaires }) => {
  const [coproprietaire, setCoproprietaire] = useState(null)
  const [copro, setCopro] = useState(null)
  return (
    <>
      <div>
        <Menus
          coproprietaire={coproprietaire}
          copro={copro}
          setCoproprietaire={setCoproprietaire}
          setCopro={setCopro}
          coproprietaires={coproprietaires}
        />
      </div>
    </>
  )
}

export const CoproprietaireExtranet = (props) => {
  const [coproprietaires, setCoproprietaires] = useState()
  const middleofficeRequest = useAxiosPrivate()
  const fetchData = async () => {
    const res = await middleofficeRequest.get('middleoffice/coowners')
    setCoproprietaires(res.data)
  }
  useEffect(() => {
    fetchData()
  }, [])

  if (!coproprietaires) return <LoadingScreen />

  return <Portal coproprietaires={coproprietaires} />
}
